/* eslint-disable indent */
import { TasklistService } from '@/api/tasklist'
import { DefaultButton } from '@/components/ui/Button'
import TableVariableRenderer from './TableVariableRenderer'

export const VariableRenderer = ({ fieldSpec, taskData }: any) => {
  return (
    <div className="border-2 border-[#c4c4c480] rounded-xl">
      <div className="flex flex-col p-4">
        <label className="text-lg sm:text-xl font-semibold mb-4" htmlFor={fieldSpec.name}>
          {fieldSpec.label}
        </label>
        <div className="overflow-x-auto">
          <table className="table-auto w-full mx-auto">
            {Object.entries(fieldSpec.properties).map(([key, value], index) => {
              if (taskData.variables[value as string | number]) {
                return (
                  <tr key={`${fieldSpec.name}-${index}`} className="">
                    <td className="font-medium py-2 pl-2 pr-6 text-sm sm:text-md">{key}</td>
                    {BodyVariableRenderer({ fieldSpec, taskData, value, key })}
                  </tr>
                )
              }
            })}
          </table>
        </div>
      </div>
    </div>
  )
}

const BodyVariableRenderer = ({ taskData, value, key }: any) => {
  const { mutate, isLoading } = TasklistService.useDownloadFile()
  const genuineValue = taskData.variables[value as string | number]

  const handleClick = (urlDownload: string, label: string) => {
    mutate({ urlDownload: urlDownload, name: label })
  }

  const renderValue = () => {
    if (typeof genuineValue === 'string') {
      if (genuineValue.includes('/download/')) {
        return (
          <td className="pr-2 text-sm sm:text-md">
            <DefaultButton
              className="h-min"
              onClick={() => handleClick(genuineValue, key)}
              type="button"
              size="small"
              loading={isLoading}
            >
              Download {key}
            </DefaultButton>
          </td>
        )
      }

      if (genuineValue.includes('https://')) {
        return (
          <td className="pr-2 text-sm sm:text-md whitespace-pre-line">
            <a href={genuineValue} target="_blank" rel="noopener noreferrer" className="text-blue-500">
              {genuineValue}
            </a>
          </td>
        )
      }

      try {
        const jsonArray = JSON.parse(genuineValue)
        if (Array.isArray(jsonArray) && jsonArray.every(item => typeof item === 'object' && !Array.isArray(item))) {
          return (
            <td className="col-span-2 row-span-2">
              <TableVariableRenderer jsonArray={jsonArray} />
            </td>
          )
        }
      } catch (error) {
        return (
          <td className="pr-2 text-sm sm:text-md whitespace-pre-line">
            <span>{genuineValue?.toString()}</span>
          </td>
        )
      }
    }

    return (
      <td className="pr-2 text-sm sm:text-md whitespace-pre-line">
        <span>{genuineValue?.toString()}</span>
      </td>
    )
  }

  return renderValue()
}
